module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/217-virgin-islands-34afca12bf9b66d517d3f8e1839dfca1.svg";